import cloneDeep from 'lodash/cloneDeep'
import find from 'lodash/find'
import { Glossary } from '@/types/glossary'

const BaseLang = 'en'

export default function getPageLangDefinition(
  definition: Glossary,
  pageLang: string
) {
  const definitionInPageLang: any = cloneDeep(definition)
  if (pageLang === BaseLang) {
    return { ...definitionInPageLang, locale: BaseLang }
  }

  const translatedDefinition = definition.translations.filter(
    (x) => x.locale === pageLang
  )

  if (translatedDefinition.length) {
    const { id, locale, data } = translatedDefinition[0]
    const translatedDefinitionObj = {
      ...definitionInPageLang,
      ...data,
      id: id,
      locale: locale,
    }

    return translatedDefinitionObj
  } else {
    return { ...definitionInPageLang, locale: BaseLang }
  }
}
